import React from 'react';
import { Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid, Table, TableHead, TableRow, TableCell, TableBody, Divider, Chip } from '@material-ui/core'


import Ws from '../providers/Ws';
import Utils from '../providers/Utils';
import DocumenteTaskRows from './DocumenteTaskRows';
import SpecificComponent from './SpecificComponent';




export default class BugetEtapaTaskB extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            fullScreen: false,
            isOpenInsertCost: false,
            numeProdus: 'Denumire cheltuiala',
            numeCostP: 'Denumire cheltuiala',
            cantitate: 0,
            pret: 0,
            tva: 19,
            valoriTva: new Utils().valoriTva,
            totalValoare: 0,
            costInfo: {},
            costuriCost: [],
            costToAdd: { denumire: '', cantitate: 0, pret: 0, tva: 19 },
            tipuriTVA: [{ id: 0, nume: 'NU' }, { id: 1, nume: 'DA' }]
        }
    }

    componentDidMount() {
        this.getWindowDimentions()
       
        console.log('this.props.subCosturi :>> ', this.props.subCosturi);
    }

    ws = new Ws()

    getWindowDimentions = () => {
        let windowWidth = window.innerWidth


        this.setState({
            fullScreen: windowWidth <= 800 ? true : false
        })

    }



    changeCellValue = (ev) => {
        // console.log('ev :', ev);
        this.setState({
            [ev.target.name]: ev.target.value,

        })
    }


    changeCost = (ev) => {

        this.setState({ numeCostP: ev.target.value })
    }




    changeObjToAdd = (ev) => {


        let val = ev.target.value
        let n = ev.target.name

        let objToAdd = { ...this.state.costToAdd }

        objToAdd[n] = val

        this.setState({ costToAdd: objToAdd })
    }


    addCost = async () => {


        let costToAdd = { ...this.state.costToAdd }

        costToAdd['id_cost'] = this.props.cheltuialaSelectata.id

        let insertCost = await this.ws.insert('bugete_taskuri_rows', costToAdd)



        console.log('costToAdd :>> ', costToAdd);
        console.log('cheltuialaSelectata :>> ', this.props.cheltuialaSelectata);

        console.log('insertCost :>> ', insertCost);

        if (insertCost.Succes) {

            this.setState({
                costToAdd: { denumire: '', cantitate: '0', pret: '0', tva: this.props.tipCost === 'cost_direct' ? '19' : '0', tva_inclus:0 }
            }, () => {

                this.props.getSubCosturi(this.props.cheltuialaSelectata)
            })
        }


    }

    deleteCost = async (c) => {
        let delCost = await this.ws.update('bugete_taskuri_rows', { sters: 1 }, { id: c.id })

        if (delCost.Succes) {
            this.props.getSubCosturi(this.props.cheltuialaSelectata)
        }
    }

    updateCost = async (c) => {
        let objToUpdate = {
            cantitate: c.cantitate,
            denumire: c.denumire,
            pret: c.pret,
            tva: c.tva,
            tva_inclus:c.tva_inclus || 0
        }

        console.log('c :>> ', c);

        console.log('objToUpdate :>> ', objToUpdate);


        let updateC = await this.ws.update('bugete_taskuri_rows', objToUpdate, { id: c.id })

        if (updateC.Succes) {
            this.props.getSubCosturi(this.props.cheltuialaSelectata)
        }
    }



    goToFile = (f) => {
        let adresaFisa = new Ws().adresaMedia + `/Taskuri/Docs/${f.document_token}`

        window.open(adresaFisa)
    }

    goToFileSubcost = (f) =>{
        let adresaFisa = new Ws().adresaMedia + `/Taskuri/Cheltuieli/${f.token}`

        window.open(adresaFisa)
    }


    deleteDoc = async (d) => {

        // console.log('d :>> ', d);

        let delDoc = await this.ws.update('taskuri_documente', { sters: 1 }, { id: d.id })

        if (delDoc.Succes) {
            this.props.getTaskData()
        }
    }

    deleteDocSubcost = async (d) =>{

        let delDoc = await this.ws.update('bugete_taskuri_rows_documente', { sters: 1 }, { id: d.id })

        if (delDoc.Succes) {
            this.props.selectCost(this.props.cheltuialaSelectata)
        }
    }

    addFileCost = (id) => {
        let pi = document.getElementById(id)

        pi.click()
    }

    uploadCostDoc = async (id, idTask, c) => {
        console.log('id :>> ', id);
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        console.log('saveFile :>> ', saveFile);

        let reader = new FileReader();

        reader.readAsDataURL(saveFile);


        console.log('reader :>> ', reader);

        reader.onload = async () => {
            let fileContent = reader.result;
            
                let uploadImage = await ws.uploadimage('Upload/DocTask', saveFile, idTask, this.props.proiectInfo[0].id, 'buget', -1 , c.id);

                console.log('uploadImage COST :', uploadImage);
                if (uploadImage.Succes) {
                    this.props.getTaskData()
                }
            }

         
        
    }

    uploadCostDocRow = (id, buget) => {
        console.log('id :>> ', id);
        let ws = new Ws();
        //  console.log('Picture changed func');
        let saveFile = document.getElementById(id).files[0];
        console.log('saveFile :>> ', saveFile);

        let reader = new FileReader();

        reader.readAsDataURL(saveFile);


        console.log('reader :>> ', reader);

        reader.onload = async () => {
            let fileContent = reader.result;


            let uploadImage = await ws.uploadCostRow('Upload/DocTaskBugetCost', saveFile, null, buget.id);

            console.log('uploadImage COST :', uploadImage);
            if (uploadImage.Succes) {
                this.props.selectCost(this.props.cheltuialaSelectata)
            }
        }
    }

    updateCostTotal = () => {

        if (this.props.cheltuialaSelectata.id) {
            let subCosturi = [...this.props.subCosturi]

            let sum = 0
            for (let i = 0, n = subCosturi.length; i < n; i++) {
                if(Number(subCosturi[i].tva_inclus) === 1){
                    sum += (subCosturi[i].pret * subCosturi[i].cantitate)
                }else {
    
                    sum += ((subCosturi[i].pret * subCosturi[i].cantitate) * subCosturi[i].tva) / 100 + (subCosturi[i].pret * subCosturi[i].cantitate)
                }
                
            }

            console.log('sum :>> ', sum);

            this.props.updateCost(sum)
        } else {
            this.props.dialogClose()
        }


    }


    changeUserCost = async(u,c) =>{
        console.log('u :>> ', u);

        let objToUpdate = {
           
            denumire: u.id,
            pret:u.cost_minut || 0,
            tva:0
           
        }

        console.log('c :>> ', c);

        console.log('objToUpdate :>> ', objToUpdate);


        let updateC = await this.ws.update('bugete_taskuri_rows', objToUpdate, { id: c.id })

        if (updateC.Succes) {
            this.props.getSubCosturi(this.props.cheltuialaSelectata)
            // this.docTask.current.reMountChild()
        }
    }




    render() {
        return (
            <div>
                <Dialog
                    className="pm-alert-dialog"
                    disableEscapeKeyDown
                    fullWidth={true}
                    maxWidth='lg'
                    fullScreen={this.state.fullScreen}
                    open={this.props.open}
                    onClose={this.updateCostTotal}>
                    <DialogActions >
                        <Fab onClick={this.updateCostTotal}
                            className="pm-round-button-dialog"
                            style={{ boxShadow: 'none', backgroundColor: 'transparent' }}
                        >
                            <i style={{ color: 'black', fontSize: 28, fontWeight: 500 }} className='material-icons'>close</i>
                        </Fab>
                    </DialogActions>

                    <DialogContent>
                        <Grid container className='pm-insert-task-header'>
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                <h4 style={{ margin: 0 }}>{this.dictionary.proiecte.budgetManagement}</h4>


                            </Grid>

                            {/* {this.props.cheltuialaSelectata.id &&
                                <Grid style={{ marginTop: 20 }} item xs={6} sm={6} md={6} lg={6} xl={6} >
                                    <div style={{
                                        display: 'flex', justifyContent: 'space-between', padding: '6px 10px',
                                        backgroundColor: '#f1f1f1'
                                    }}>
                                        <span style={{ fontSize: 14, fontWeight: 400, color: 'gray' }}>{this.props.cheltuialaSelectata.document_nume ? this.props.cheltuialaSelectata.document_nume : 'Ataseaza Document'}</span>

                                        <input type='file' id={`fileCost1`}
                                            style={{ display: 'none' }}
                                            accept='.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, .pdf'
                                            onChange={() => { this.uploadCostDoc(`fileCost1`, this.props.objInfoTask.id, this.props.cheltuialaSelectata) }} />

                                        <i onClick={() => { this.addFileCost('fileCost1') }} style={{ verticalAlign: 'middle', color: 'gray', cursor: 'pointer' }} className='material-icons'>insert_drive_file</i>

                                    </div>


                                </Grid>

                            } */}

                            {/* <Grid style={{ marginTop: 20, textAlign: 'left' }} item xs={6} sm={6} md={6} lg={6} xl={6} >
                                <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='denumireCost'>Denumire Cost</label>
                                <input
                                    id='denumireCost'
                                    style={{ width: '90%', marginLeft: 10 }}
                                    className='add-project-input'
                                    type="text"
                                    margin="normal"
                                    name='nume'
                                    // onBlur={this.props.insertOrUpdateCost}
                                    value={this.props.numeCost || ''}

                                    onChange={this.props.changeNumeCheltuiala}
                                />





                            </Grid> */}

                            <Grid style={{ marginTop: 20, textAlign: 'left' }} item xs={6} sm={6} md={6} lg={6} xl={6} >
                                <div style={{ position: 'relative' }}>
                                    <input
                                        id='denumireCost'
                                        style={{ width: '90%', marginLeft: 10 }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='nume'
                                        onBlur={this.props.insertOrUpdateCost}
                                        value={this.props.numeCost || ''}
                                        placeholder={this.dictionary.proiecte.budgetName}
                                        onChange={this.props.changeNumeCheltuiala}
                                    />




                                    <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='denumireCost'>{this.dictionary.proiecte.budgetName}</label>

                                </div>
                            </Grid>

                            <Grid style={{ marginTop: 20, textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <div style={{ position: 'relative' }}>
                                    <select
                                        id='tipCost'
                                        style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='tva'
                                        value={this.props.tipCost}
                                        onChange={this.props.changeTip}
                                        placeholder={this.dictionary.proiecte.typeSelect}
                                        onBlur={this.props.insertOrUpdateCost}
                                    >


                                        {this.props.tipuriCost.map((l, idx) => {
                                            return (
                                                <option key={idx} value={l.id}>{l.nume}</option>
                                            )
                                        })}
                                    </select>
                                    <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.proiecte.budgetType}</label>
                                </div>

                            </Grid>

                            <Grid style={{ marginTop: 20, textAlign: 'left' }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <div style={{ position: 'relative' }}>
                                    <select
                                        style={{ width: '90%', paddingTop: 9, paddingBottom: 9 }}
                                        className='add-project-input'
                                        type="text"
                                        margin="normal"
                                        name='tva'
                                        value={this.props.tipIntroducere}
                                        onChange={this.props.changeTipIntroducere}
                                        placeholder={this.dictionary.proiecte.addType}
                                    // onBlur={this.props.insertOrUpdateCost}
                                    >


                                        {this.props.tipuriIntroducere.map((l, idx) => {
                                            return (
                                                <option key={idx} value={l.id}>{l.nume}</option>
                                            )
                                        })}

                                    </select>
                                    <label style={{ marginLeft: 10 }} className='inputLabelPM' htmlFor='tipCost'>{this.dictionary.proiecte.addType}</label>
                                </div>
                            </Grid>



                            <Grid style={{ margin: '10px 0 10px 0' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Divider style={{ width: '100%' }} />

                            </Grid>

                            {/* {this.props.cheltuialaSelectata.id && */}
                                <Grid item xs={12} sm={12} md={12} lg={12} xl={12} >
                                    <DocumenteTaskRows
                                        listaCosturi={this.props.subCosturi}
                                        costToAdd={this.state.costToAdd}
                                        changeObjToAdd={this.changeObjToAdd}
                                        changeObj={this.props.changeObj}
                                        addCost={this.addCost}
                                        valoriTva={this.state.valoriTva}
                                        deleteCost={this.deleteCost}
                                        updateCost={this.updateCost}
                                        tipuriTVA={this.state.tipuriTVA}
                                        bugete={this.props.bugete}
                                        alocaBuget={this.alocaBuget}
                                        tipIntroducere={this.props.tipIntroducere}
                                        cost={false}
                                        openFile={this.addFileCost}
                                        uploadCostDoc={this.uploadCostDocRow}
                                        tipCost={this.props.tipCost}
                                        changeUserCost={this.changeUserCost}
                                        listUsers={this.props.listUsers}
                                       
                                    />


                                </Grid>
                            {/* } */}

                            <Divider style={{ width: '100%' }} />

                            <Grid style={{ marginBottom: 20, marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>

                                <div id='list-atasamente' style={{ display: 'flex', }}>

                                    <div style={{ marginLeft: 10 }}>
                                        <input type='file' id={`fileTask1`}
                                            style={{ display: 'none' }}
                                            onChange={() => { this.uploadCostDoc(`fileTask1`, this.props.objInfoTask.id, this.props.cheltuialaSelectata) }} />


                                        <div style={{ display: 'inline-block', marginBottom: 10 }} id='atasament-nou' onClick={() => { this.addFileCost('fileTask1') }}>
                                            <span id='cheltuieli-label' className='insert-task-labels'> <span style={{
                                                fontSize: 14,
                                                fontWeight: 400,
                                                color: '#579ae8'
                                            }}>{this.dictionary.proiecte.addAttachment}
                            <div

                                                    style={{ display: "inline-block" }}
                                                >

                                                    <i
                                                        style={{ fontSize: 20, verticalAlign: 'sub', color: 'black', marginLeft: 10 }}
                                                        className='material-icons pm-standard-icons'>attachment</i>


                                                </div>
                                            </span>
                                            </span>

                                        </div>
                                        {this.props.listDocumente.filter(d => d.id_buget === this.props.cheltuialaSelectata.id).map((d, idx) => {
                                            // console.log('d :>> ', d);

                                            return (
                                                <Chip
                                                    key={idx}
                                                    label={<span style={{ color: 'black' }} onClick={() => { this.goToFile(d) }}> <i style={{ verticalAlign: 'middle', fontSize: 18, marginRight: 5 }} className='material-icons'>description</i>{d.nume}</span>}
                                                    onDelete={() => { this.deleteDoc(d) }} color="primary"
                                                    style={{ backgroundColor: '#f1f1f1', marginLeft: 20, marginBottom: 10 }}
                                                    deleteIcon={<i className='material-icons pm-chip-delete-icon' style={{fontSize:21}}>clear</i>}
                                                />
                                                // <div key={idx}><span className='insert-task-labels'>
                                                //     <span onClick={() => { this.goToFile(d) }}>{d.nume}</span> <i style={{ verticalAlign: 'middle', fontSize: 20 }} className='material-icons'
                                                //      onClick={() => { this.deleteDoc(d) }}>delete</i></span></div>
                                            )
                                        })}

                                        {this.props.docSubcosturi.map((d, idx) => {
                                            // console.log('d :>> ', d);

                                            return (
                                                <Chip
                                                    key={idx}
                                                    label={<span style={{ color: 'black' }} onClick={() => { this.goToFileSubcost(d) }}> <i style={{ verticalAlign: 'middle', fontSize: 18, marginRight: 5 }} className='material-icons'>description</i>{d.nume}</span>}
                                                    onDelete={() => { this.deleteDocSubcost(d) }} color="primary"
                                                    style={{ backgroundColor: '#f1f1f1', marginLeft: 20, marginBottom: 10 }}
                                                    deleteIcon={<i className='material-icons pm-chip-delete-icon' style={{fontSize:21}}>clear</i>}
                                                />
                                                // <div key={idx}><span className='insert-task-labels'>
                                                //     <span onClick={() => { this.goToFile(d) }}>{d.nume}</span> <i style={{ verticalAlign: 'middle', fontSize: 20 }} className='material-icons'
                                                //      onClick={() => { this.deleteDoc(d) }}>delete</i></span></div>
                                            )
                                        })}





                                    </div>

                                </div>



                            </Grid>
                            {/* 
                            {this.props.cheltuialaSelectata.id &&

                                <Grid style={{ textAlign: 'left' }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                    <Button
                                        style={{
                                            backgroundColor: '#19a63c',
                                            color: 'white',
                                            padding: 10,
                                            borderRadius: 10
                                        }}
                                        onClick={() => { this.updateCostTotal() }}>
                                        Salveaza Cheltuiala

                                    </Button>
                                </Grid>

                            } */}


                        </Grid>

                    </DialogContent>
                    {/* <h2 className='pm-dialog-alert-title'>{this.props.title}</h2> */}


                    {/* <div className='container' style={{ textAlign: 'center' }}>

                        <div style={{ textAlign: "center", marginBottom: 20, padding: 15 }}>
                            <Button onClick={() => { this.setState({ isOpenInsertCost: true }) }} className="pm-adauga-button">
                                <i className='material-icons pm-round-button-text'>add</i>
                                Adauga Cost
                     </Button>
                        </div>
                        {this.props.costuriEtapa.length > 0 &&
                            <CosturiListProiect
                                elemente={this.props.costuriEtapa}
                                dict={this.dictionary}
                                onlyColumns={{ nume: 'nume', valoare: 'valoare', data_costului: 'data_costului' }}

                                numeChange={this.props.numeConstChange}
                                updateNume={this.props.updateNume}
                                valoareChange={this.props.valoareCostChange}
                                updateValoare={this.props.updateValoareCost}
                                dataChange={this.props.dataCostChange}
                                updateData={this.props.updateDataCost}
                            />
                        }

                        <Button style={{ marginTop: 10 }} onClick={this.props.dialogClose} className="pm-adauga-button">

                            Salveaza
          </Button>

                        {/* <CosturiTipuriList
                            getTipuriCost={this.props.getTipuriCost}
                            elemente={this.props.costuriTipuri}
                            dict={this.props.dict}
                            onlyColumns={{nume:'nume'}}
                               onElClick={this.props.costAdd} /> */}
                    {/* </div> */}



                </Dialog>

                {/* <AddCosturiProiect

                    open={this.state.isOpenInsertCost}
                    dialogClose={() => { this.setState({ isOpenInsertCost: false }) }}
                    title={this.dictionary.bugete.addCost}
                    numeProdus={this.state.numeProdus}
                    cantitate={this.state.cantitate}
                    pret={this.state.pret}
                    tva={this.state.tva}
                    changeCellValue={(ev) => { this.changeCellValue(ev) }}
                    dict={this.dictionary}
                    costAdd={this.insertCost}
                    total={(Number(this.state.pret) + (Number(this.state.pret) * Number(this.state.tva) / 100)) * Number(this.state.cantitate)}
                    totalNet={(Number(this.state.pret) * Number(this.state.cantitate))}
                    totalTva={(Number(this.state.pret) * Number(this.state.tva) / 100) * Number(this.state.cantitate)}
                /> */}
            </div>
        );
    }
}